<template>
  <v-dialog v-model="visible" max-width="500px">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-form>
          <v-row>
            <v-col cols="12">
              <v-text-field v-model="form.nombre" label="Área" outlined dense hide-details clearable></v-text-field>

              <small v-for="error in errores.nombre" :key="error" class="d-inline-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <!-- <v-col cols="12">
              <v-radio-group v-model="form.tipo" row>
                <v-radio label="TEÓRICO" value="teorico"></v-radio>
                <v-radio label="PRÁCTICO" value="practico"></v-radio>
              </v-radio-group>
            </v-col> -->
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text :disabled="enviando" @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn
          color="blue darken-1"
          text
          :disabled="enviando"
          :loading="enviando"
          @click.prevent="() => validar(registrar, editar)">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import modalFormMixin from '../mixins/modal-form.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import AreaUniversidadService from '../services/area-universidad.service';

export default {
  name: 'ModalFormularioAreaUniversidad',
  mixins: [modalFormMixin, apiConsumerMixin],
  props: {
    universidadId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      conceptos: [],
    };
  },
  watch: {
    'form.nombre': function () {
      this.errores.nombre = [];
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        nombre: null,
        tipo: 'teorico',
        universidadId: this.universidadId,
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        nombre: data.nombre,
        tipo: data.tipo,
        universidadId: data.universidadId,
      };
    },
    abrir(accion, data = []) {
      this.abrirMixin(accion, data);
    },
    guardar(accion) {
      this.guardarDatosMixin(
        AreaUniversidadService.create,
        AreaUniversidadService.update,
        accion,
        this.form,
        this.nombreRecurso,
        () => {
          this.$emit('actualizarListado');
          this.cerrar();
        },
        (errores) => {
          this.errores = errores;
        },
      );
    },
    registrar() {
      this.guardar(this.accionesCrud.REGISTRAR);
    },
    editar() {
      this.guardar(this.accionesCrud.EDITAR);
    },
  },
};
</script>